import { cn } from '@/lib/utils';

export const GlassPanel = ({ children, className, variant = 'soft', ...props }) => {
  return (
    <div
      className={cn(
        'rounded-2xl border',
        variant === 'soft'
          ? 'border-white/10 bg-white/[0.06] backdrop-blur-[14px] shadow-[0_18px_60px_rgba(0,0,0,0.45)]'
          : 'border-white/[0.14] bg-white/[0.10] backdrop-blur-[18px] shadow-[0_18px_60px_rgba(0,0,0,0.5)]',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
